import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

import { BsPlusLg } from "react-icons/bs";
import { AiOutlineArrowLeft, AiOutlineArrowRight } from "react-icons/ai";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";
import ReactImageFallback from "react-image-fallback";
import { toast, ToastContainer } from "react-toastify";

import Footer1 from "../components/Footers/Footer1.component";
import AuthHeader from "../components/Headers/AuthHeader.component";
import ReactPlayer from "react-player";
import { MdLocationOn } from "react-icons/md";
import Loader from '../components/Loader.component';


export default function EditJob(props) {

    const { id } = useParams();

    let navigate = useNavigate();
    /**
     * 0 = default screen of categories
     * 1 = add proposal information
     */
    // Local State
    const [post, setPost] = useState("");
    const [userScreen, setUserScreen] = useState(0);
    const [categories, setCategories] = useState(null);
    const [serviceName, setServiceName] = useState("");
    const [imgPreview, setImgPreview] = useState([]);
    const [videoPreview, setVideoPreview] = useState([]);
    const [latlong, setLatLong] = useState({});
    // object of any message with type
    const [flag, setFlag] = useState('');

    // Redux State
    const token = useSelector(state => state.auth.token);
    const userData = useSelector(state => state.auth.data);
    const services = useSelector(state => state.services.services);

    // setting services 
    useEffect(() => {
        setCategories(services);
    }, [services]);

    const formik = useFormik({
        initialValues: {
            categoryName: "",
            category: "",
            title: !post ? "" : post.title,
            photos: [],
            videos: [],
            workScope: "",
            deadline: "",
            price: null,
            // pay_with: null,
            pay_with: 1,
            lat: '',
            lng: '',
            status: 1
        },
        validationSchema: Yup.object({
            title: Yup.string()
                .min("10", "Must have atleast 7 characters.")
                .required("Required"),
            photos: Yup.mixed().required("Required"),
            workScope: Yup.string()
                .min("7", "Must have atleast 7 characters.")
                .required("Required"),
            deadline: Yup.string().required("Required"),
            price: Yup.number().min(10, 'Min of $10').required("Required"),
        }),
        onSubmit: async (values) => {
            let createJobData = new FormData();
            createJobData.append("service_id", parseInt(values.category));
            createJobData.append("customer_id", userData.id);
            createJobData.append("price", values.price);
            createJobData.append("title", values.title);
            createJobData.append("description", values.workScope);
            createJobData.append("pay_with", values.pay_with);
            createJobData.append("task_completion_date", values.deadline);
            createJobData.append("lat", values.lat);
            createJobData.append("long", values.lng);
            createJobData.append("address", "Islamabad");
            createJobData.append("status", values.status);

            Object.keys(values.photos).forEach(item => {
                // console.log(values.photos[item]);
                createJobData.append("post_images[]", values.photos[item]);
            });
            Object.keys(values.videos).forEach(item => {
                // console.log(values.photos[item]);
                createJobData.append("post_videos[]", values.videos[item]);
            });

            setFlag({
                type: "job_submit",
                message: "Please Wait..."
              });
              

            await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts/${id}`, {
                method: "POST",
                headers: {
                    "Authorization": `Bearer ${token}`
                },
                body: createJobData
            })
                .then(r => r.json())
                .then(response => {
                    if (response.success) {
                        console.log("Job Created Successfully ", response.records);
                        // setFlag({type: "success", message: response.message});
                        toast.success(response.message);

                        setTimeout(() => {
                            navigate("/my-jobs", { replace: true });
                        }, 2000);

                    } else {
                        toast.warn(response.message);
                        // setFlag({type: "error", message: response.message});
                    }
                    setFlag({});                      
                })
        }
    });


    // Deadline date
    const setDeadlineDate = (date) => {
        formik.setFieldValue("deadline", date);
    }

    const handleSelectImages = (e) => {
        let images = e.target.files;
        let imgarr = Array.from(images);
        if (images.length <= 4) {
            let arImg = imgarr.map(item => {
                return URL.createObjectURL(item);
            });
            setImgPreview(arImg);

            formik.setFieldValue("photos", images);
            setFlag('');

        } else {
            setFlag({
                type: "uploadImgErr",
                message: "Maximum of 4 images are allowed"
            });
        }
    }

    const handleSelectVideos = (e) => {
        let video = e.target.files;
        if (video.length <= 4) {
            let videarr = Array.from(video);
            let arVid = videarr.map(item => {
                return URL.createObjectURL(item);
            });
            setVideoPreview(arVid);
            formik.setFieldValue("videos", video);
            setFlag('');
        } else {
            setFlag({
                type: "uploadVideoErr",
                message: "Maximum of 4 Videos are allowed"
            });
        }
    }
    const resetAllImages = (e) => {
        e.preventDefault();
        formik.setFieldValue("photos", []);
        setImgPreview([]);
    }
    const resetAllVideos = (e) => {
        e.preventDefault();
        formik.setFieldValue("videos", []);
        setVideoPreview([]);
    }


    // getting post data 
    useEffect(() => {
        const getSinglePostData = async () => {
            await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts?post_id=${id}`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            })
                .then(r => r.json())
                .then(response => {
                    if (response.success) {
                        setPost(response.records.data[0]);

                        let data = response.records.data[0];
                        setServiceName(data.service.service_name);
                        formik.setFieldValue("title", data.title);
                        formik.setFieldValue("category", data.service.id);
                        formik.setFieldValue("categoryName", data.service.service_name);
                        formik.setFieldValue("workScope", data.description);
                        formik.setFieldValue("deadline", data.task_completion_date);
                        // formik.setFieldValue("deadline", "");
                        formik.setFieldValue("price", data.price);
                        formik.setFieldValue("pay_with", data.pay_with);
                        formik.setFieldValue("lat", data.lat);
                        formik.setFieldValue("lng", data.long);
                        formik.setFieldValue("status", data.status)

                        let images = data.images && data.images.length > 0 ? data.images.map(item => {
                            let img = process.env.REACT_APP_BASE_URL + "/public/storage/" + item.filepond.filepath;
                            return img;
                        }) : [];
                        // formik.setFieldValue("photos", images);  
                        setImgPreview(images);

                        let videos = data.videos && data.videos.length > 0 ? data.videos.map(item => {
                            let img = process.env.REACT_APP_BASE_URL + "/public/storage/" + item.filepond.filepath;
                            return img;
                        }) : [];
                        setVideoPreview(videos);
                        // formik.setFieldValue("videos", videos);  

                    } else {
                        toast.error(response.message);
                    }
                })
        }
        getSinglePostData();
    }, []);

    return (
        <>

            <AuthHeader />
            {
                !post ? <Loader /> :
                    <section className="bds-main-section bg-light-blue bg-leaf">
                        <div className="container bg-gray theme-rounded-40 py-5">
                            <div className="row">
                                <form encType="multipart/form-data" onSubmit={formik.handleSubmit}>
                                    <div className="col-lg-8 mx-auto">
                                        <div className="bds-sectiontitle user-profile">
                                            <div className="bds-featureRating">
                                                {userScreen == 0 && (
                                                    <div>
                                                        <h3><span className="fw-light">Pick the Service</span> <br />You need</h3>
                                                        <div className="select_category_container ">
                                                            {categories !== null &&
                                                                categories.map((cat, idx) => (
                                                                    <div
                                                                        className={`category_item ${formik.values.category == cat.id
                                                                            ? "active-card"
                                                                            : ""
                                                                            }`}
                                                                        key={idx}
                                                                    >
                                                                        <label htmlFor={`cat_painting${idx}`}>
                                                                            <ReactImageFallback
                                                                                src={`https://3bidsapp.com/dev/public/storage/${cat?.service_image}`}
                                                                                fallbackImage="/images/default_featured_img.png"
                                                                                initialImage="/images/default_featured_img.png"
                                                                                alt={cat.service_name}
                                                                                width={100}
                                                                                height={100}
                                                                                className="img-fluid my-3"
                                                                            />
                                                                            <h6>{cat.service_name}</h6>
                                                                        </label>
                                                                        <input
                                                                            type="radio"
                                                                            name="category"
                                                                            value={cat.id}
                                                                            onChange={(e) => {
                                                                                formik.setFieldValue(
                                                                                    "category",
                                                                                    e.target.value
                                                                                );
                                                                                setServiceName(cat.service_name);
                                                                            }}
                                                                            id={`cat_painting${idx}`}
                                                                            className="d-none"
                                                                        />
                                                                    </div>
                                                                ))}
                                                        </div>

                                                        <div className="d-flex justify-content-between flex-wrap ">
                                                            <button
                                                                className="btn bds-btn-solid"
                                                                type="button"
                                                                onClick={() =>
                                                                    formik.values.category.length == 0
                                                                        ? ""
                                                                        : setUserScreen(1)
                                                                }
                                                                disabled={
                                                                    formik.values.category.length == 0 ? true : false
                                                                }
                                                            >
                                                                <span className="me-2">Next</span>{" "}
                                                                <AiOutlineArrowRight />
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}

                                                {userScreen == 1 && (
                                                    <>
                                                        <div className="form-group flex-column align-items-start px-0">
                                                            <h3 className="mb-4 text-center w-100">
                                                                {serviceName}
                                                            </h3>
                                                            <label className="fw-bold text-dark">Project Title</label>
                                                            <div
                                                                className={`bds-placeholderholder ${formik.touched.title && formik.errors.title
                                                                    ? "border border-danger"
                                                                    : ""
                                                                    }`}
                                                            >
                                                                <input
                                                                    name="title"
                                                                    type="text"
                                                                    className={`form-control bds-themeinput bg-white`}
                                                                    placeholder="Project Title"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.title}
                                                                />
                                                            </div>
                                                            <p className="m-0">
                                                                {formik.touched.title && formik.errors.title ? (
                                                                    <small className="text-danger">
                                                                        {formik.errors.title}
                                                                    </small>
                                                                ) : null}
                                                            </p>
                                                        </div>

                                                        <div className="media_content">
                                                            <h4 className="fw-bold text-dark">Add Images</h4>
                                                            {flag?.type === "uploadImgErr" && (
                                                                <p className="mb-0 text-danger">
                                                                    <small>{flag?.message}</small>
                                                                </p>
                                                            )}

                                                            {imgPreview.length > 0 && (
                                                                <button
                                                                    className="btn btn-link ms-auto d-block text-sky-blue p-0"
                                                                    onClick={(e) => resetAllImages(e)}
                                                                >
                                                                    Reset All Images
                                                                </button>
                                                            )}
                                                            <div className="media_content_container">
                                                                {imgPreview.length > 0 &&
                                                                    imgPreview.map((item, idx) => (
                                                                        <img
                                                                            key={idx}
                                                                            src={`${item}`}
                                                                            alt="service-photo"
                                                                            width={100}
                                                                            height={100}

                                                                            className="bg-secondary"
                                                                        />
                                                                    ))}
                                                                <div
                                                                    className={`addMedia_wrapper ${imgPreview.length > 3 ? "d-none" : ""
                                                                        }`}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className="addMedia_btn btn"
                                                                        onClick={() =>
                                                                            document
                                                                                .getElementById("projectPhotos")
                                                                                .click()
                                                                        }
                                                                    >
                                                                        <BsPlusLg />
                                                                    </button>
                                                                    <input
                                                                        type="file"
                                                                        name="photos[]"
                                                                        id="projectPhotos"
                                                                        className="d-none"
                                                                        accept="image/*"
                                                                        // accept="image/png, image/jpeg, image/jpeg, image/gif, image/svg, image/webp"
                                                                        multiple
                                                                        onChange={(e) => handleSelectImages(e)}
                                                                    />
                                                                </div>
                                                            </div>

                                                            <p className="m-0">
                                                                {formik.touched.photos && formik.errors.photos ? (
                                                                    <small className="text-danger">
                                                                        {formik.errors.photos}
                                                                    </small>
                                                                ) : null}
                                                            </p>
                                                        </div>

                                                        <div className="media_content">
                                                            <h4 className="fw-bold text-dark">Add Videos</h4>
                                                            {flag?.type === "uploadVideoErr" && (
                                                                <p className="mb-0 text-danger">
                                                                    <small>{flag?.message}</small>
                                                                </p>
                                                            )}
                                                            {videoPreview.length > 0 && (
                                                                <button
                                                                    className="btn btn-link ms-auto d-block text-sky-blue p-0"
                                                                    onClick={(e) => resetAllVideos(e)}
                                                                >
                                                                    Reset All Videos
                                                                </button>
                                                            )}
                                                            <div className="media_content_container overflow-hidden">
                                                                {videoPreview.length > 0 &&
                                                                    videoPreview.map((item, idx) => (
                                                                        <ReactPlayer
                                                                            key={idx}
                                                                            url={item}
                                                                            width={150}
                                                                            height={140}
                                                                            controls={true}
                                                                        />
                                                                    ))}
                                                                <div className="addMedia_wrapper">
                                                                    <button
                                                                        type="button"
                                                                        className="addMedia_btn btn"
                                                                        onClick={() =>
                                                                            document
                                                                                .getElementById("projectVideos")
                                                                                .click()
                                                                        }
                                                                    >
                                                                        <BsPlusLg />
                                                                    </button>
                                                                    <input
                                                                        type="file"
                                                                        name="videos[]"
                                                                        id="projectVideos"
                                                                        className="d-none"
                                                                        accept="video/*"
                                                                        multiple
                                                                        onChange={(e) => handleSelectVideos(e)}
                                                                    />
                                                                </div>
                                                            </div>
                                                            <p className="m-0">
                                                                {formik.touched.videos && formik.errors.videos ? (
                                                                    <small className="text-danger">
                                                                        {formik.errors.videos}
                                                                    </small>
                                                                ) : null}
                                                            </p>
                                                        </div>

                                                        <div className="form-group flex-column align-items-start px-0">
                                                            <label className="fw-bold text-dark">What do you need</label>
                                                            <div
                                                                className={`w-100 theme-rounded-25 ${formik.touched.workScope &&
                                                                    formik.errors.workScope
                                                                    ? "border border-danger"
                                                                    : ""
                                                                    }`}
                                                            >
                                                                <textarea
                                                                    name="workScope"
                                                                    className={`form-control bg-white theme-rounded-25 w-100`}
                                                                    placeholder="Define your Project"
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.workScope}
                                                                />
                                                            </div>
                                                            <p className="m-0">
                                                                {formik.touched.workScope &&
                                                                    formik.errors.workScope ? (
                                                                    <small className="text-danger">
                                                                        {formik.errors.workScope}
                                                                    </small>
                                                                ) : null}
                                                            </p>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-lg-4 col-md-6">
                                                                <div className="form-group flex-column align-items-start px-0">
                                                                    <label className="fw-bold text-dark">My Budget</label>
                                                                    <div
                                                                        className={`bds-placeholderholder bg-white ${formik.touched.price && formik.errors.price
                                                                            ? "border border-danger"
                                                                            : ""
                                                                            }`}
                                                                    >
                                                                        <span className="ps-3">$</span>
                                                                        <input
                                                                            name="price"
                                                                            type="number"
                                                                            className={`form-control bds-themeinput bg-white ps-2`}
                                                                            placeholder="Project Price"
                                                                            onChange={formik.handleChange}
                                                                            onBlur={formik.handleBlur}
                                                                            value={formik.values.price}
                                                                        />
                                                                    </div>
                                                                    <p className="m-0">
                                                                        {formik.touched.price && formik.errors.price ? (
                                                                            <small className="text-danger">
                                                                                {formik.errors.price}
                                                                            </small>
                                                                        ) : null}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* <div className="row my-4">
                                                                <div className="col-lg-4 col-md-6">
                                                                    <div className="form-group flex-column align-items-start px-0">
                                                                    <h6 className="mb-3">Accept Payment from:</h6>

                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                        className="form-check-label d-flex align-items-center"                                  
                                                                        >
                                                                        <input
                                                                            className="form-check-input bds-form-check-input-sm me-3"
                                                                            type="radio"
                                                                            name="pay_with"
                                                                            value="1"
                                                                            onChange={formik.handleChange}
                                                                        />
                                                                        <MdDeliveryDining />
                                                                        <span className="ms-2 text-dark">Cash on Delivery</span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                        className="form-check-label d-flex align-items-center"                                  
                                                                        >
                                                                        <input
                                                                            className="form-check-input bds-form-check-input-sm me-3"
                                                                            type="radio"
                                                                            name="pay_with"
                                                                            value="2"
                                                                            onChange={formik.handleChange}
                                                                        />
                                                                        <FaCcPaypal />
                                                                        <span className="ms-2 text-dark">Paypal</span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                        className="form-check-label d-flex align-items-center"                                  
                                                                        >
                                                                        <input
                                                                            className="form-check-input bds-form-check-input-sm me-3"
                                                                            type="radio"
                                                                            name="pay_with"
                                                                            value="3"   
                                                                            onChange={formik.handleChange}                              
                                                                        />
                                                                        <FaCcStripe />
                                                                        <span className="ms-2 text-dark"> Stripe</span>
                                                                        </label>
                                                                    </div>

                                                                    <p className="m-0">
                                                                        {formik.touched.price && formik.errors.price ? (
                                                                        <small className="text-danger">
                                                                            {formik.errors.price}
                                                                        </small>
                                                                        ) : null}
                                                                    </p>
                                                                    </div>
                                                                </div>
                                                                </div> */}
                                                        <div className="row my-4">
                                                            <div className="col-lg-4 col-md-6">
                                                                <div className="form-group flex-column align-items-start px-0">
                                                                    <h6 className="mb-3">Change Job Status:</h6>

                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                            className="form-check-label d-flex align-items-center"
                                                                        >
                                                                            <input
                                                                                className="form-check-input bds-form-check-input-sm me-3"
                                                                                type="radio"
                                                                                name="status"
                                                                                value={1}
                                                                                onChange={formik.handleChange}
                                                                                checked={formik.values.status == 1 ? true : false}
                                                                            />
                                                                            <span className="ms-2 text-dark">Pending</span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                            className="form-check-label d-flex align-items-center"
                                                                        >
                                                                            <input
                                                                                className="form-check-input bds-form-check-input-sm me-3"
                                                                                type="radio"
                                                                                name="status"
                                                                                value={2}
                                                                                onChange={formik.handleChange}
                                                                                checked={formik.values.status == 2 ? true : false}
                                                                            />
                                                                            <span className="ms-2 text-dark">In Progress</span>
                                                                        </label>
                                                                    </div>
                                                                    <div className="bds-form-checkbox">
                                                                        <label
                                                                            className="form-check-label d-flex align-items-center"
                                                                        >
                                                                            <input
                                                                                className="form-check-input bds-form-check-input-sm me-3"
                                                                                type="radio"
                                                                                name="status"
                                                                                value={3}
                                                                                onChange={formik.handleChange}
                                                                                checked={formik.values.status == 3 ? true : false}
                                                                            />
                                                                            <span className="ms-2 text-dark"> Completed</span>
                                                                        </label>
                                                                    </div>

                                                                    <p className="m-0">
                                                                        {formik.touched.status && formik.errors.status ? (
                                                                            <small className="text-danger">
                                                                                {formik.errors.status}
                                                                            </small>
                                                                        ) : null}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="form-group flex-column align-items-start px-0">
                                                            <label className="fw-bold text-dark">Date Contractor Start Work</label>
                                                            <div
                                                                className={`bds-placeholderholder overflow-visible ${formik.touched.deadline && formik.errors.deadline
                                                                    ? "border border-danger"
                                                                    : ""
                                                                    }`}
                                                            >
                                                                <input
                                                                    name="deadline"
                                                                    type="date"
                                                                    min={moment().format("YYYY-MM-DD")}
                                                                    className={`form-control bds-themeinput bg-white`}
                                                                    onChange={formik.handleChange}
                                                                    onBlur={formik.handleBlur}
                                                                    value={formik.values.deadline}
                                                                />                                                                
                                                                {/* <DatePicker
                                                                    selected={formik.values.deadline}
                                                                    onChange={date => setDeadlineDate(date)}
                                                                    minDate={moment().toDate()}
                                                                    className={`form-control bds-themeinput bg-white theme-rounded-25`}
                                                                /> */}
                                                            </div>
                                                            <p className="m-0">
                                                                {formik.touched.deadline &&
                                                                    formik.errors.deadline ? (
                                                                    <small className="text-danger">
                                                                        {formik.errors.deadline}
                                                                    </small>
                                                                ) : null}
                                                            </p>
                                                        </div>

                                                        {/* <div className="form-group flex-column align-items-start px-0">
                                                            <label className="fw-bold text-dark">Select Your Location / Coordinates </label>
                                                            <div
                                                                className={`bds-placeholderholder theme-rounded-25 }`}
                                                            >
                                                                <input
                                                                name="location"
                                                                type="text"
                                                                className={`form-control bds-themeinput bg-white`}
                                                                onChange={formik.handleChange}
                                                                onBlur={formik.handleBlur}
                                                                placeholder="Enter your Address"                             
                                                                />
                                                            </div>                         
                                                            </div> */}

                                                        <div className="d-flex justify-content-between flex-wrap mt-5">
                                                            <button
                                                                className="btn bds-btn-solid"
                                                                type="button"
                                                                onClick={() => setUserScreen(0)}
                                                            >
                                                                <AiOutlineArrowLeft />{" "}
                                                                <span className="ms-2">Back</span>
                                                            </button>
                                                            <button className="btn bds-btn-solid" type="submit" disabled={flag && flag.type == "job_submit" ? true : false}>
                                                                {
                                                                    flag && flag.type == "job_submit" ? flag.message : "Update Job"
                                                                }
                                                            </button>
                                                        </div>
                                                        
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </section>
            }

            <ToastContainer />
            <Footer1 />
        </>
    );
}
